<template>
  <!-- 翱锐简介 -->
  <div class="intro" v-show="loadover">
    <!-- 电脑 -->
    <div>
      <video :src="pageCate.info.attachment" controls muted poster></video>
    </div>
    <div v-html="pageCate.info.content"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "introduction",
  data() {
    return {
      loadover:false,
      info: {},
    };
  },
  computed: mapGetters(["pageCate"]),
  mounted(){
    this.$nextTick(()=>{
      this.loadover=true
    })
  }
};
</script>
<style scoped lang='less'>
//   翱锐简介
.intro {
  display: flex;
  justify-content: center;
  > div:first-child {
    margin-right: 5.72vw;
    background: url("../../assets/image/电脑样机@2x.png") no-repeat;
    background-size: 100% 100%;
    min-width: 20.1vw;
    height: 15.99vw;
    position: relative;
    > video {
      width: 18.5vw;
      height:  10.3125vw;
      position: absolute;
      top: 0.78125vw;
      left: 0.78125vw;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/go/introductionG.vue